const zh = {
  appName: '知识库',
  uploadFiles: '上传文件',
  upload: '上传',
  cancel: '取消',
  dashboard: '概览',
  allFiles: '全部文件',
  fileBrowser: '文件目录',
  starred: '已收藏',
  recent: '最近',
  tags: '标签',
  categories: '分类',
  trash: '回收站',
  settings: '设置',
  help: '帮助',
  searchPlaceholder: '搜索订单、文件夹、文件…',
  searchFilesPlaceholder: '搜索文件…',
  search: '搜索',
  notifications: '通知',
  expandSidebar: '展开侧栏',
  collapseSidebar: '收起侧栏',
  profile: '个人资料',
  signOut: '退出登录',
  language: '语言',
  switchLanguage: '切换语言',

  // Files page
  filesTitle: '文件',
  filter: '筛选',
  sort: '排序',
  sortName: '名称',
  sortDate: '日期',
  sortSize: '大小',
  noFilesFound: '没有找到文件',
  noStarredTip: '暂无收藏文件，收藏重要文件以便快速找到。',
  fileType: {
    all: '全部文件',
    document: '文档',
    image: '图片',
    video: '视频',
    audio: '音频',
    pdf: 'PDF',
    spreadsheet: '表格',
    presentation: '演示文稿',
  },

  // Upload modal
  uploadTitle: '上传文件',
  uploadTo: '上传到',
  dropOrBrowse: '拖放文件或文件夹到这里，或',
  browseFiles: '浏览文件',
  browseFolders: '浏览文件夹',
  supportedTypesTip: '支持的文件：文档、图片、视频等',
  uploadFromUrl: '从URL上传文件',
  urlPlaceholder: '输入文件URL链接',
  filenamePlaceholder: '文件名',
  uploading: '上传中...',
  selectedFiles: '已选择文件',
  uploadingProgress: '正在上传 {{processed}}/{{total}} ...',
  enterFileUrl: '请输入文件URL',
  enterFilename: '请输入文件名',
  uploadFailedPrefix: '上传失败：',

  // Captcha
  captchaPlaceholder: '请输入图形验证码',
  captchaInvalid: '验证码不正确，请重试',

  // File list
  fileListTitle: '文件列表',
  generateThumbnails: '生成缩略图',
  processing: '处理中...',
  processedStats: '已处理 {{processed}} / {{total}} 个文件{{failed}}',
  failed: '失败',
  headerName: '名称',
  headerType: '类型',
  headerSize: '大小',
  headerModified: '修改时间',
  headerTags: '标签',
  headerActions: '操作',

  // Search modal
  searchModalPlaceholder: '搜索文档、图片或任何内容…',
  searchBy: '搜索方式：',
  tabAll: '全部',
  tabTags: '标签',
  tabType: '文件类型',
  tabCombined: '组合',
  filterByTags: '按标签筛选：',
  filterByType: '按文件类型筛选：',
  searchHelpStart: '开始输入以搜索文件…',
  searchHelpHint: '可按文件名、内容、标签或类型搜索',
  searchNoResultsFor: '没有找到与“{{query}}”相关的结果',
  searchAdjust: '请调整关键字或筛选条件再试',
  viewAllResults: '查看全部 {{count}} 条结果',
  escToClose: '按 ESC 关闭',
  arrowsToNavigate: '↑↓ 导航，回车选择',

  // File card & details
  moveTo: '移动到…',
  delete: '删除',
  goBack: '返回',
  save: '保存',
  downloadFile: '下载文件',
  renameFile: '重命名文件',
  uploadCustomThumbnail: '上传自定义缩略图',
  updateThumbnail: '更新缩略图',
  uploadThumbnail: '上传缩略图',
  captureVideoFrameAsThumb: '将当前帧设为缩略图',
  capturePdfPageAsThumb: '将当前页面设为缩略图',
  refreshThumbnail: '刷新缩略图',
  refreshingThumbnail: '正在刷新…',
  refreshThumbnailFailedPrefix: '刷新缩略图失败: ',
  thumbnailUrl: '缩略图地址',
  fileUrl: '文件地址',
  description: '描述',
  fileInformation: '文件信息',
  type: '类型',
  created: '创建时间',
  lastModified: '修改时间',
  size: '大小',
  owner: '所有者',
  deleteFileTitle: '删除文件',
  deleteFileConfirm: '确定要删除“{{name}}”吗？此操作不可撤销。',
  confirmDelete: '删除',
  shareLinkCopied: '分享链接已复制！',
  loadingImage: '图片加载中…',
  loadingPDF: 'PDF 加载中…',
  loadingVideo: '视频加载中…',
  prevPage: '上一页',
  nextPage: '下一页',
  pageIndicator: '第 {{current}} / {{total}} 页',
  previewFallbackTip: '正在尝试加载预览，如无法预览，您可以下载后在本地查看或上传自定义缩略图。',
  pleaseSelectValidImage: '请选择有效的图片文件',
  videoThumbUpdated: '视频缩略图已成功更新，点击复制缩略图链接可获取最新地址',
  pdfThumbUpdated: 'PDF缩略图已成功更新，点击复制缩略图链接可获取最新地址',
  thumbnailUrlCopied: '缩略图URL已复制',
  fileUrlCopied: '文件URL已复制',
  cannotUploadThumbMissingStorage: '无法上传缩略图：文件存储信息缺失',
  uploadThumbnailFailedPrefix: '上传缩略图失败: ',
  onlyImageForThumbnail: '只支持上传图片文件作为缩略图',
  allThumbnailsRefreshed: '所有缩略图已刷新',
  thumbnailRefreshed: '缩略图已刷新',
  thumbnailRefreshedButPartial: '缩略图已刷新，但有部分数据处理错误',
  fileNotFound: '未找到文件',
  noPreviewAvailable: '此文件类型不支持在线预览，请下载后在本地查看。',
  officePreviewPoweredBy: '由 Microsoft Office Online 提供预览',
  loadingCode: '正在加载文件内容…',
  loadCodeFailed: '无法加载文件内容',
  fullscreen: '全屏',
  exitFullscreen: '退出全屏',
  close: '关闭',

  // Categories page
  categoriesAll: '全部分类',
  breadcrumbCategories: '分类',
  itemsSection: '项目',
  createSubfolder: '新建子文件夹',
  renameCategory: '重命名',
  bulkActions: '批量操作',
  exitSelection: '退出选择',
  moveCurrentCategory: '移动当前分类',
  clearAndDeleteCategory: '清空并删除分类',
  moveThisCategory: '移动该分类',
  clearAndDeleteThisCategory: '清空并删除该分类',
  folder: '文件夹',
  filesLabel: '个文件',
  more: '更多',
  selectAllFiles: '全选文件',
  selectAllSubfolders: '全选子文件夹',
  clearSelection: '清空选择',
  generateThumbnailsQuick: '一键生成缩略图',
  deleteWithFolders: '删除（含文件夹）',
  deleteQuick: '一键删除',
  categoryNotFound: '未找到该分类',
  moveToTitle: '移动到',
  selectDestinationFolder: '选择目标文件夹',
  pleaseConfirmMove: '请确认移动操作：',
  willMoveTheseItems: '将移动以下 {{count}} 项：',
  next: '下一步',
  confirmMove: '确认移动',
  moving: '移动中…',
  renameCategoryTitle: '重命名分类',
  newName: '新名称',
  renameCategoryUniqueNote: '同一父分类下名称需唯一。',
  saving: '保存中…',
  openClearAndDelete: '打开清空并删除分类',
  confirmDeletionTitle: '确认删除',
  selectedFoldersWarning: '已选 {{count}} 个文件夹。为安全起见，请先对这些文件夹执行“清空并删除分类”。',
  deleteSelectionIntro: '将删除以下 {{count}} 个文件：',
  andMore: '… 以及另外 {{n}} 个',
  deletingProgress: '正在删除 {{processed}}/{{total}}',
  deleteFilesAction: '删除文件',
  clearAndDeleteCategoryTitle: '清空并删除分类',
  clearConfirmFiles: '将删除分类“{{name}}”整棵子树内的所有文件（{{count}} 个），包含所有子文件夹。是否继续？',
  clearDeletingFiles: '正在删除分类中的文件…',
  clearConfirmDeleteCategory: '所有文件已删除。是否删除分类 “{{name}}”？',
  deleteCategoryAction: '删除分类',
  moveCategoryTitle: '移动分类',
  selectNewParentFolder: '选择新的上级文件夹',
  pleaseConfirmMoveCategory: '请确认移动分类：',
  categoryLabel: '分类：',
  selectionSummary: '已选 {{total}} 个（文件 {{files}} / 文件夹 {{folders}}）',

  // Auth & login/register
  welcomeBack: '欢迎回来',
  noAccount: '还没有账号？',
  signUp: '注册',
  emailAddress: '邮箱地址',
  password: '密码',
  signingIn: '登录中...',
  signInAction: '登录',
  invalidEmailOrPassword: '邮箱或密码错误',
  createAccount: '创建账户',
  haveAccount: '已经有账号？',
  confirmPassword: '确认密码',
  creatingAccount: '创建中...',
  createAccountAction: '创建账户',
  emailRequired: '邮箱必填',
  passwordRequired: '密码必填',
  passwordsDoNotMatch: '两次输入的密码不一致',
  passwordMinLength: '密码长度至少 6 位',
  unableToCreateAccount: '暂时无法创建账户，请稍后再试。',
  failedToCreateAccount: '创建账户失败',
  passwordWeak: '弱',
  passwordMedium: '中',
  passwordStrong: '强',
  passwordsMatch: '密码匹配',
  checkEmailTitle: '邮件已发送',
  checkEmailSubtitle: '我们已发送确认链接。请保留此页面，完成邮箱确认后会自动进入门户。',
  confirmationEmailSentTo: '确认邮件已发送至',
  openEmailToConfirm: '打开邮件并点击“确认邮箱”。',
  autoRedirectAfterConfirm: '确认完成后，此页面会自动进入文件门户。',
  iveConfirmedContinue: '我已确认，进入门户',
  checkingConfirmation: '正在检查确认状态...',
  confirmationPendingNotice: '还没有检测到已确认的登录状态，请先点击邮件中的确认链接。',
  confirmationCheckFailed: '暂时无法检查确认状态，请稍后重试。',
  editEmail: '更换邮箱',

  // Password reset
  forgotPassword: '忘记密码？',
  resetPasswordTitle: '重置密码',
  resetPasswordDesc: '输入您的注册邮箱，我们将发送密码重置链接。',
  sendResetLink: '发送重置链接',
  sendingResetLink: '发送中...',
  resetEmailSent: '重置邮件已发送！请检查您的收件箱。',
  resetEmailSentDesc: '如果没有收到邮件，请检查垃圾邮件文件夹。',
  backToLogin: '返回登录',
  setNewPassword: '设置新密码',
  setNewPasswordDesc: '请输入您的新密码。',
  newPassword: '新密码',
  updatePasswordAction: '更新密码',
  updatingPassword: '更新中...',
  passwordResetSuccess: '密码已更新！正在跳转到登录页...',
  tryAgain: '重试',

  // Magic Link / OTP login
  passwordLogin: '密码登录',
  magicLinkLogin: '验证码登录',
  magicLinkDesc: '输入邮箱，我们将发送验证码到您的邮箱。',
  sendMagicLink: '发送验证码',
  sendingMagicLink: '发送中...',
  magicLinkSent: '验证码已发送！',
  magicLinkSentDesc: '请查看您的收件箱，输入收到的 6 位验证码。',
  magicLinkError: '发送验证码失败，请稍后重试。',
  emailNotRegistered: '该邮箱未注册，请先注册账户。',
  otpSentTo: '验证码已发送至',
  otpVerifyAction: '验证并登录',
  otpVerifyError: '验证码错误或已过期，请重试。',
  otpResend: '重新发送',
  otpChangeEmail: '更换邮箱',
  otpPlaceholder: '请输入验证码',
  otpResent: '已发送',

  // Tags page
  tagsTitle: '标签',
  newTag: '新建标签',
  allTags: '全部标签',
  addTag: '添加标签',
  tagColor: '标签颜色',
  filesWithThisTag: '包含该标签的文件',
  noFilesWithThisTag: '暂无包含该标签的文件',
  selectTagToView: '选择一个标签查看关联文件',
  deleteTagConfirm: '确定删除该标签吗？此操作不可撤销。',

  // Trash page
  trashTitle: '回收站',
  trashAutoDelete: '回收站的项目将在 30 天后自动删除',
  emptyTrash: '清空回收站',
  trashEmpty: '回收站为空',
  noItemsInTrash: '暂无回收站项目',
  autoDeleteNotice: '回收站内的项目将在 30 天后自动删除',
  restoreAll: '全部还原',
  confirmEmptyTrash: '确定要永久删除回收站中的所有项目吗？此操作不可撤销。',

  // Dashboard page
  totalFiles: '文件总数',
  categoriesLabel: '分类',
  recentlyUpdated: '最近更新',
  viewAll: '查看全部',
  noRecentFiles: '暂无最近文件，开始上传内容以在此查看。',
  starredFilesTitle: '已收藏文件',
  quickAccess: '快捷访问',
  viewManageAllFiles: '查看并管理你的所有文件',
  accessImportantFiles: '快速访问重要文件',
  recentWorkedOn: '你最近处理过的文件',
  browseByCategory: '按分类浏览文件',
  storageCardTitle: '存储',
  storageFull: '存储已满',
  storageWarning: '存储预警',
  manageStorage: '管理存储',
  used: '已用：',
  total: '总计：',
  others: '其他',
  updatedLabel: '更新于',
  addToStarred: '添加到收藏',
  removeFromStarred: '取消收藏',
  versionHistory: '版本历史',

  // Header status & actions
  refreshingData: '正在刷新所有数据...',
  dataRefreshed: '数据已刷新',
  refreshFailed: '刷新失败，请重试',
  processingThumbnails: '正在批量处理缩略图...',
  processThumbDone: '缩略图处理完成：成功 {{processed}} 个',
  processThumbDoneWithFailed: '缩略图处理完成：成功 {{processed}} 个，失败 {{failed}} 个',
  processThumbFailed: '批量处理失败：{{message}}',
  refreshData: '刷新数据',
  processMissingThumbnails: '处理缺失的缩略图',

  // Storage warnings
  storageAlmostFullMsg: '存储空间即将用尽！请释放一些空间。',
  storageGettingFullMsg: '存储空间趋于紧张，建议清理旧文件。',

  // Category selector
  searchFoldersPlaceholder: '搜索文件夹…',
  createFolder: '新建文件夹',
  folderNamePlaceholder: '文件夹名称',
  nameRequired: '名称不能为空',
  nameExists: '同层级已存在该名称',
  createFailed: '创建失败',

  // Help page
  helpCenter: '帮助中心',
  documentation: '文档',
  documentationDesc: '浏览我们的完整指南与文档',
  videoTutorials: '视频教程',
  videoTutorialsDesc: '观看步骤清晰的视频教程',
  communityForum: '社区论坛',
  communityForumDesc: '与其他用户交流与分享',
  contactSupport: '联系支持',
  contactSupportDesc: '获取支持团队的帮助',
  faq: '常见问题',
  needMoreHelp: '需要更多帮助？',
  supportAvailable: '我们的支持团队 7x24 小时在线',
  contactSupportAction: '联系支持',
  faqHowUploadQ: '如何上传文件？',
  faqHowUploadA: '点击导航栏的“上传”按钮，或将文件直接拖放进页面。',
  faqSupportedTypesQ: '支持哪些文件类型？',
  faqSupportedTypesA: '支持常见的文档、图片、视频及音频等类型。',
  faqHowShareQ: '如何分享文件？',
  faqHowShareA: '打开文件详情，点击“分享”生成链接或邀请指定用户。',
  faqDeletedFilesQ: '删除的文件会怎样？',
  faqDeletedFilesA: '删除的文件会进入回收站，30 天后将被永久删除。',

  // Settings page
  profileSettings: '个人资料设置',
  savedSuccess: '保存成功',
  editProfile: '编辑资料',
  nameLabel: '姓名',
  phoneLabel: '手机号码',
  languagePreference: '语言偏好',
  chinese: '中文',
  english: '英文',
  notSet: '未设置',
  accountInfo: '账号信息',
  accountRole: '账号角色',
  admin: '管理员',
  userRole: '普通用户',
  registeredAt: '注册时间',
  lastPasswordChange: '最后密码修改',
  changePassword: '修改密码',

  // 个人资料页面（门户）
  profilePage: {
    loginRequired: '请登录后查看个人中心',
    backToFiles: '返回文件',
    nameNotSet: '未设置姓名',
    clickToChangeAvatar: '点击头像即可更换',
    uploading: '上传中',
    personalInfo: '个人资料',
    edit: '编辑',
    name: '姓名',
    email: '邮箱',
    save: '保存',
    cancel: '取消',
    passwordSettings: '密码设置',
    changePasswordBtn: '修改密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    newPasswordPlaceholder: '请输入新密码（至少6位）',
    confirmPasswordPlaceholder: '请再次输入新密码',
    updatePassword: '更新密码',
    passwordHint: '点击"修改密码"按钮来更新您的登录密码',
    accountActions: '账户操作',
    signOut: '退出登录',
    // 成功/失败消息
    profileUpdated: '个人资料更新成功',
    profileUpdateFailed: '更新失败，请重试',
    passwordUpdated: '密码更新成功',
    passwordUpdateFailed: '更新密码失败，请重试',
    passwordMismatch: '新密码和确认密码不匹配',
    passwordTooShort: '新密码至少需要6位',
    avatarUpdated: '头像更新成功',
    avatarUpdateFailed: '头像更新失败，请重试',
    signOutFailed: '退出登录失败，请重试',
  },
  storageOverviewTitle: '存储总览',
  storageByTypeTitle: '按类型统计',
  storageManagementTitle: '存储管理',
  cleanUpAssistantTitle: '清理助手',
  cleanUpAssistantDesc: '查找并移除重复或大文件',
  run: '运行 →',
  storageAnalyticsTitle: '存储分析',
  storageAnalyticsDesc: '查看存储使用的详细分析',
  view: '查看 →',
  upgradeStorageTitle: '升级存储',
  upgradeStorageDesc: '获取更多的存储空间',
  upgrade: '升级 →',
  notificationSettingsTitle: '通知设置',
  notificationSettingsDesc: '配置你的通知偏好。',
  securitySettingsTitle: '安全设置',
  securitySettingsDesc: '管理安全与隐私设置。',
  sharingCollabTitle: '共享与协作',
  sharingCollabDesc: '配置共享与协作相关设置。',
  trashManagementTitle: '回收站管理',
  trashManagementDesc: '管理已删除文件与恢复选项。',
  settingsMenu: {
    profile: '个人资料',
    storage: '存储管理',
    notifications: '通知',
    security: '安全',
    sharing: '共享与协作',
    trash: '回收站管理',
  },

  // Create category modal
  createCategory: {
    titleRoot: '新建分类',
    titleSub: '新建子分类',
    creatingUnder: '创建于',
    nameLabel: '分类名称',
    namePlaceholder: '输入分类名称',
    cancel: '取消',
    submit: '创建分类',
    errorRequired: '分类名称必填',
    errorDuplicate: '同一父级下名称已存在',
    duplicateNameHint: '该名称已存在于当前层级，请更换。',
  },

  // Portal - 门户页面
  portal: {
    title: '洲明文件资源门户',
    titleShort: '文件门户',
    loginToSeeMore: '登录查看更多',
    adminPanel: '管理面板',
    collaborativeWhiteboard: '协作白板',
    admin: '管理',
    userProfile: '个人资料',
    logout: '退出登录',
    allFiles: '全部文件',
    orderQuery: '订单查询',
    folders: '文件夹',
    searchPlaceholder: '搜索文件、订单号、文件夹...',
    allTypes: '所有类型',
    batchActions: '批量操作',
    preview: '预览',
    download: '下载',
    gridView: '网格视图',
    listView: '列表视图',
    noResults: '未找到相关文件',
    tryDifferentKeyword: '尝试使用其他关键词搜索',
    // 侧边栏相关
    collapseSidebar: '收起侧边栏',
    expandSidebar: '展开侧边栏',
    favorites: '收藏夹',
    unfavorite: '取消收藏',
    favorite: '收藏',
    noFolders: '暂无文件夹',
    // 筛选相关
    activeFilters: '已选筛选',
    clearFilters: '清除',
    folder: '文件夹',
    // 可见性标签
    visibilityPublic: '公开',
    visibilityRestricted: '受限',
    visibilityPrivate: '私有',
    // 订单查询
    order: '订单',
    orderNumber: '订单号',
    orderNumberInputPlaceholder: '请输入订单号',
    orderPlaceholder: '输入订单号...',
    searching: '查询中...',
    searchNow: '立即查询',
    orderTip: '💡 输入订单号快速添加到您的账户',
    orderQueryHint: '输入文件夹对应的订单号，获取限时访问权限',
    queryButton: '查询',
    querySuccessRedirecting: '查询成功！正在跳转...',
    // 列表表头
    headerName: '名称',
    headerType: '类型',
    headerSize: '大小',
    headerActions: '操作',
    headerSelect: '选择',
    selectedItems: '已选 {{count}} 项',
    downloadSelected: '下载选中',
    // 筛选状态
    currentFilter: '当前筛选',
    orderSearch: '📋 订单搜索',
    folderSearch: '📁 文件夹搜索',
    fileSearch: '📄 文件搜索',
    typeLabel: '类型',
    folderLabel: '文件夹',
    tagsLabel: '标签',
    tagsCount: '{{count}} 个',
    noMatchingFiles: '没有找到匹配的文件',
    noPublicFiles: '暂无公开文件',
    // 访客状态横幅
    guestBannerTitle: '当前显示公开文件 ({{count}} 个)',
    guestBannerDescription: '登录后可以查看更多您有权限访问的文件',
    // 批量操作
    exitBatchMode: '退出批量',
    selectAll: '全选',
    deselectAll: '取消全选',
    emptyFolder: '空文件夹',
    nameNotSet: '未设置姓名',
    notSet: '未设置',
    // 导航和筛选
    allFilesHome: '全部文件',
    subfolders: '子文件夹',
    subfoldersCount: '子文件夹 ({{count}})',
    clearAll: '清除全部',
    pressEnterToSearch: '按回车搜索文件',
    searchResults: '搜索结果',
  },

  // Theme - 主题
  theme: {
    light: '浅色模式',
    dark: '深色模式',
    system: '跟随系统',
    switchToLight: '切换到浅色模式',
    switchToDark: '切换到深色模式',
  },

  // Footer - 页脚
  footer: {
    copyright: '洲明科技文件管理系统',
    design: '设计',
  },

  // 权限级别 - Permission levels
  permissions: {
    basic: '初级',
    intermediate: '中级',
    advanced: '高级',
    uploader: '上传管理员',
    admin: '管理员',
    super_admin: '超级管理员',
    public: '公开',
  },

  // Common actions - 通用操作
  common: {
    search: '搜索',
    loading: '加载中...',
    downloading: '下载中...',
    error: '发生错误',
    retry: '请稍后再试',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    update: '更新',
    close: '关闭',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    reset: '重置',
    clear: '清除',
    selectAll: '全选',
    deselectAll: '取消全选',
    noData: '暂无数据',
    open: '打开',
    copiedToClipboard: '已复制到剪贴板',
  },

  // Cookie Banner - Cookie 横幅
  cookie: {
    title: '隐私与Cookie偏好',
    description: '洲明重视您的隐私。我们使用Cookie来提升体验、分析访问并优化服务。',
    gdprCompliant: '符合GDPR及全球隐私法规',
    customizeSettings: '自定义设置',
    essentialOnly: '仅必需',
    acceptAll: '接受全部',
    savePreferences: '保存偏好设置',
    essentialCookies: '必需Cookie',
    essentialCookiesDesc: '网站正常运行所必需，包括身份验证和安全功能。',
    analyticsCookies: '分析Cookie',
    analyticsCookiesDesc: '帮助我们了解用户行为，优化产品体验和性能。',
    functionalCookies: '功能Cookie',
    functionalCookiesDesc: '记住您的偏好设置，提供个性化内容和服务。',
    marketingCookies: '营销Cookie',
    marketingCookiesDesc: '用于展示相关的广告和推广内容。',
  },

  // 租户管理 - Tenant Management
  tenant: {
    cn: '国内',
    intl: '国际',
    switchTenant: '切换租户',
    currentTenant: '当前租户',
    allTenants: '所有租户',
    tenantLabel: '租户',
  },
};

export default zh;
export type ZhLocale = typeof zh;



